import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select as RubickSelect } from "@libs/rubick";
import { forwardRef } from "react";
import { MessageBox } from "./MessageBox";
export const SELECT_MSG_BOX = 'select-msg-box';
export const Select = /*#__PURE__*/ forwardRef(({ className, 'data-testid': dataTestId, errors, label, children, ...props }, ref)=>{
    const labelClass = 'mb-2 mt-0 block text-sm font-medium text-gray-700';
    const messageBoxTestId = dataTestId ?? 'default';
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            !!label && /*#__PURE__*/ _jsx("label", {
                className: labelClass,
                children: label
            }),
            /*#__PURE__*/ _jsx(RubickSelect, {
                ref: ref,
                className: className,
                "data-testid": dataTestId,
                ...props,
                children: children
            }),
            !!errors && errors.message && /*#__PURE__*/ _jsx(MessageBox, {
                className: "px-4 py-2 mb-6",
                "data-testid": messageBoxTestId + '_' + SELECT_MSG_BOX,
                message: errors.message,
                type: "error"
            })
        ]
    });
});
